import React from 'react'

function Login() {
  return (
    <div>
    <p>login</p>
    </div>
  )
}

export default Login